var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShareSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5225_10066)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 10.3008C15.95 10.3008 15.5 10.7508 15.5 11.3008V15.3008C15.5 15.8508 15.05 16.3008 14.5 16.3008H3.5C2.95 16.3008 2.5 15.8508 2.5 15.3008V4.30075C2.5 3.75075 2.95 3.30075 3.5 3.30075H7.5C8.05 3.30075 8.5 2.85075 8.5 2.30075C8.5 1.75075 8.05 1.30075 7.5 1.30075H3.5C1.85 1.30075 0.5 2.65075 0.5 4.30075V15.3008C0.5 16.9508 1.85 18.3008 3.5 18.3008H14.5C16.15 18.3008 17.5 16.9508 17.5 15.3008V11.3008C17.5 10.7508 17.05 10.3008 16.5 10.3008Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.42 0.920751C18.32 0.680751 18.12 0.480751 17.88 0.380751C17.76 0.330751 17.63 0.300751 17.5 0.300751H11.5C10.95 0.300751 10.5 0.750751 10.5 1.30075C10.5 1.85075 10.95 2.30075 11.5 2.30075H15.09L8.80001 8.59075C8.41001 8.98075 8.41001 9.61075 8.80001 10.0008C9.00001 10.2008 9.25001 10.2908 9.51001 10.2908C9.77001 10.2908 10.02 10.1908 10.22 10.0008L16.51 3.71075V7.30075C16.51 7.85075 16.96 8.30075 17.51 8.30075C18.06 8.30075 18.51 7.85075 18.51 7.30075V1.30075C18.51 1.17075 18.48 1.04075 18.43 0.920751H18.42Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5225_10066"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(0.5 0.300751)"
})))));
export default SvgIconShareSmall;